import ThankYouComponent from './ThankYouComponent';
import { TEXT } from 'locales/translations';
import { Link } from 'react-router-dom';
import { linkHandler } from 'utils/linkHandler';

export const ThankYou = () => {
  return (
    <ThankYouComponent showFooter>
      <Link to={linkHandler.get('library')} className="btn btn-grey-c100 d-sm-inline-block">
        {TEXT.thankYou.btnLibrary}
      </Link>
    </ThankYouComponent>
  );
};

export default ThankYou;
